<template>
  <div class="project-description container">
    <div class="project-description__content">
      <h1
        class="project-description__title display-5 color-darken-1 font-weight-light mb-5"
      >
        Memoria descriptiva
      </h1>
      <div
        :class="['project-description__item', item.long ? 'item-long' : '']"
        v-for="(item, i) in content"
        :key="`project-detail-${i}`"
      >
        <h5
          class="project-description__item__header color-darken-1 font-weight-bold"
        >
          {{ item.header }}
        </h5>
        <template v-if="item.long">
          <h5
            class="project-description__item__detail color-darken-1 font-weight-light"
            v-html="item.detail"
          ></h5>
        </template>
        <template v-else>
          <h5
            class="project-description__item__detail color-darken-1 font-weight-light"
          >
            {{ item.detail }}
          </h5>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectDescription",
  props: {
    content: [Object, Array]
  },
  methods: {
    //
  }
};
</script>

<style scoped lang="sass">
.project-description
  margin-top: -4rem
  padding: 4rem 2rem
  background-color: #F8F9F8
  &__content
    max-width: 756px
    margin: 0 auto
    display: grid
    grid-template-columns: 50% 50%
  &__title
    grid-column-start: 1
    grid-column-end: 3
  &__item
    &:not(:last-child)
      margin-bottom: 1.5rem
    &.item-long
      grid-column-start: 1
      grid-column-end: 3
      ul
        padding-inline-start: 30px
        margin-top: 1rem
  @media screen and (max-width: 768px)
    margin-top: -2rem
  @media screen and (max-width: 502px)
    &__content
      padding: 0
      display: block
    &__title
      font-size: 2rem
    h5
      font-size: 1rem
</style>
